import React from "react";
import { Box, Typography } from "@mui/material";
import { enterpriseTokens } from "styles/theme";

const EnterprisePageShell = ({
  eyebrow,
  title,
  description,
  actions,
  meta,
  children,
  sx = {},
}) => {
  return (
    <Box
      sx={{
        minHeight: "100%",
        backgroundColor: "#F4F7FB",
        ...sx,
      }}
    >
      <Box
        sx={{
          px: { xs: 2, md: 2.5 },
          pt: { xs: 2, md: 2 },
          pb: { xs: 1.5, md: 1.5 },
          backgroundColor: "#FFFFFF",
          color: enterpriseTokens.navy,
          borderBottom: `1px solid ${enterpriseTokens.lineSoft}`,
        }}
      >
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            gap: 2,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box sx={{ maxWidth: 820 }}>
            {eyebrow && (
              <Typography
                sx={{
                  color: enterpriseTokens.primary,
                  fontSize: 10,
                  fontWeight: 600,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  mb: 0.5,
                }}
              >
                {eyebrow}
              </Typography>
            )}
            <Typography
              sx={{
                fontSize: { xs: 19, md: 21 },
                lineHeight: { xs: "25px", md: "27px" },
                fontWeight: 600,
                letterSpacing: 0,
              }}
            >
              {title}
            </Typography>
            {description && (
              <Typography
                sx={{
                  mt: 0.4,
                  color: enterpriseTokens.muted,
                  fontSize: 12,
                  lineHeight: "18px",
                  maxWidth: 680,
                }}
              >
                {description}
              </Typography>
            )}
            {meta && (
              <Box sx={{ mt: 1.25, display: "flex", gap: 0.75, flexWrap: "wrap", "& .MuiChip-root": { height: 22, bgcolor: "#F8FAFC !important", color: `${enterpriseTokens.slate} !important`, border: `1px solid ${enterpriseTokens.lineSoft} !important`, fontSize: 10 }, "& .MuiTypography-root": { color: `${enterpriseTokens.slate} !important` }, "& > div": { bgcolor: "#F8FAFC !important", borderColor: `${enterpriseTokens.lineSoft} !important`, minWidth: "96px !important", py: "5px !important" } }}>
                {meta}
              </Box>
            )}
          </Box>
          {actions && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
                justifyContent: { xs: "flex-start", md: "flex-end" },
              }}
            >
              {actions}
            </Box>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          px: { xs: 2, md: 2.5 },
          py: { xs: 1.5, md: 1.75 },
          color: enterpriseTokens.navy,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default EnterprisePageShell;
